import { ProIp } from "./ApiURL";

//Cancel Membership  Api Url
export const deleteMemberShipAPI = ProIp + "cancelSubscriptionRoutes/deleteMembersCreation";

//get clg data  Api Url
export const getClgDataAPI = ProIp + "institute/getInstitute";